module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail6-e13439b224d9503be319f55a9c639920.jpg";